module.exports = __webpack_public_path__ + "media/promo/velle/images/test__mob-98a7298f7b9fd3a359a5d106bc9587f9.png";